module.exports = __webpack_public_path__ + "static/media/1_pl.d0f0c388.png";